import { useState, useEffect } from "react";
import { Box, Heading, Input, Button, VStack, Text, Stack } from "@chakra-ui/react";
import axios from "axios";

export default function HerstellerForm({ existingHersteller = null, onSuccess }) {
  const [hersteller, setHersteller] = useState({ name: "", typen: [] });

  useEffect(() => {
    if (existingHersteller) {
  setHersteller({
    name: existingHersteller.name || "",
    typen: existingHersteller.typen || [],
  });
}
  }, [existingHersteller]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setHersteller((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (type) => {
    setHersteller((prev) => {
      const updated = prev.typen.includes(type)
        ? prev.typen.filter((t) => t !== type)
        : [...prev.typen, type];
      return { ...prev, typen: updated };
    });
  };

 const handleSubmit = async () => {
  if (!hersteller.name.trim()) {
    alert("Der Name wird benötigt.");
    return;
  }

  const payload = {
    name: hersteller.name,
    wechselrichter: hersteller.typen.includes("wechselrichter"),
    energiespeicher: hersteller.typen.includes("energiespeicher"),
    datenlogger: hersteller.typen.includes("datenlogger"),
    modul: hersteller.typen.includes("modul"),
  };

  try {
    if (existingHersteller) {
      await axios.put(`${process.env.REACT_APP_API_URL}/api/hersteller/${existingHersteller.id}`, payload);
      alert("Hersteller erfolgreich aktualisiert!");
    } else {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/hersteller`, payload);
      alert("Hersteller erfolgreich angelegt!");
    }
    onSuccess?.();
  } catch (err) {
    console.error("Fehler beim Speichern:", err);
    alert("Fehler beim Speichern des Herstellers.");
  }
};

  return (
    <Box maxW="4xl" mx="auto" mt={10} p={8} bg="white" borderRadius="xl" boxShadow="lg">
      <Heading size="md" mb={6} color="blue.600">
        {existingHersteller ? "Hersteller bearbeiten" : "Neuen Hersteller anlegen"}
      </Heading>

      <VStack align="stretch" spacing={4}>
        <Text fontWeight="semibold">Name</Text>
        <Input name="name" placeholder="Name" value={hersteller.name} onChange={handleChange} />

        <Text fontWeight="semibold">Hersteller-Typ</Text>
        <Stack spacing={3}>
          {["wechselrichter", "energiespeicher", "datenlogger", "modul"].map((type) => (
            <label key={type} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <input
                type="checkbox"
                checked={hersteller.typen.includes(type)}
                onChange={() => handleCheckboxChange(type)}
              />
              {type.charAt(0).toUpperCase() + type.slice(1)}
            </label>
          ))}
        </Stack>

        <Button colorScheme="blue" onClick={handleSubmit} alignSelf="flex-start">
          {existingHersteller ? "Aktualisieren" : "Anlegen"}
        </Button>
      </VStack>
    </Box>
  );
}